// simple helper function for improving readability
// this way we can avoid https://developer.mozilla.org/en-US/docs/Glossary/IIFE functions
// in the code
export function executeSoon(fn, errorHandler, cleanupFn) {
    (async () => {
        try {
            await fn();
        }
        catch (err) {
            console.error('Error while executing background task', err);
            errorHandler?.(err);
        }
        finally {
            cleanupFn?.();
        }
    })();
}
